import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import useProcessData from "../../../CommonFunction/ProcessData";
import { LoadTable, Loading } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import { useModalContext } from "../../Components/Reactportal/ModalContext";

const queryfunction = (fields: []) => {
  const query = gql`
    query getAllConnectionMemo_WithPopulate {
      getAllConnectionMemo_WithPopulate {
        _id
        Is_Lock
        ${fields?.join(" ")}
      }
    }
    `;
  return query;
};

const ConnectionPlanning = () => {
  // const { pushModal, popModal, getTopModal, modalStack } = useModalContext();
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState([]);
  const Key = "Connection_Memo";
  const config = useMemo(
    () => ({
      dataKey: "getAllConnectionMemo_WithPopulate",
      dateKeys: ["createdAt", "updatedAt"],
      deleteKeys: ["__typename", "is_Audit"],
      dateKeysWithoutTime: ["Date"],
    }),
    []
  );

  // console.log(modalStack, "modalStackmodalStackmodalStackmodalStack");
  const [fetchConnection_details, { loading: queryLoading, error, data }] = useLazyQuery(queryfunction([]), {
    fetchPolicy: "network-only",
    context: {
      headers: {
        "X-GraphQL-Server": "orion",
      },
    },
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });

  // useEffect(() => {
  //   pushModal(Key);
  // }, []);

  const { loading, TableHeaders } = useFetchTableData(queryfunction, fetchConnection_details, setIsLoading, Key);
  const { loading: processDataLoading } = useProcessData(data, setFormData, config, error);
  // const isLoading = queryLoading || processDataLoading;

  if (error?.message) {
    return (
      <>
        <HeaderDiv title={"Connection Planning (Memo)"} TableKey={Key} />
        <p className="DataNotAvailable">{error.message}</p>
      </>
    );
  }
  return (
    <>
      <HeaderDiv title="Connection Planning (Memo)" TableKey={Key} />
      {isLoading ? (
        <Loading />
      ) : !formData?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {(queryLoading || loading) && <div className="loader-line-div" />}

          <LoadTable title={Key} data={formData} loading={isLoading} error={error} TableHeaders={TableHeaders} />
        </>
      )}
    </>
  );
};

export default ConnectionPlanning;
